export const COMMERCE_AGENT_LAUNCH_START = Temporal.ZonedDateTime.from(
  "2026-10-06T10:00:00[America/Denver]",
);

/** True at and after 10:00 AM Mountain on October 6, 2026. */
export function isCommerceAgentLaunchOpen(now: Temporal.Instant): boolean {
  return (
    Temporal.Instant.compare(now, COMMERCE_AGENT_LAUNCH_START.toInstant()) >= 0
  );
}
